import { Link } from "react-router-dom";
import { Check } from "@phosphor-icons/react";
import { BrandLogo } from "../brand/BrandLogo";

const POINTS = ["Free profile – no card needed", "Your own QR code and responder link", "Family alerted on WhatsApp when it's opened"];

export default function AuthLayout({ children, mode }) {
  return (
    <div className="landing min-h-screen bg-white grid lg:grid-cols-[1fr_1.1fr]" style={{ fontFamily: "Sora, sans-serif" }} data-testid={`auth-page-${mode}`}>
      <aside className="hidden lg:flex relative overflow-hidden bg-[#16294A] text-white p-12 flex-col justify-between">
        <img src="/landing/photo_kampala.webp" alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#16294A] via-[#16294A]/70 to-transparent" />
        <Link to="/" className="relative"><BrandLogo tone="dark" size={38} tagline testid="auth-logo" /></Link>
        <div className="relative">
          <h1 className="text-4xl xl:text-5xl font-extrabold leading-[1.05]">When you can't speak, <span className="text-[#FF7A8A]">your band can.</span></h1>
          <div className="mt-8 space-y-3">{POINTS.map((p) => (
            <div key={p} className="flex items-center gap-3 text-sm"><span className="w-6 h-6 rounded-full bg-[#D7263D] flex items-center justify-center"><Check size={12} weight="bold" /></span>{p}</div>))}</div>
        </div>
        <div className="relative text-xs text-slate-400">Made in Kampala · Uganda · Kenya · Tanzania · Rwanda</div>
      </aside>
      <main className="flex flex-col items-center justify-center p-5 sm:p-10 bg-[#F7F8FB]">
        <Link to="/" className="lg:hidden mb-8"><BrandLogo size={34} testid="auth-logo-mobile" /></Link>
        {children}
        <Link to="/" className="mt-6 text-xs text-slate-500 hover:text-[#D7263D]" data-testid="auth-back-home">← Back to bsafe.today</Link>
      </main>
    </div>
  );
}
